import { Component } from '@angular/core';
import { HeaderComponent } from "../../../layout/header/header.component";
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { TokenService } from '../../../services/token.service';
import { NavbarComponent } from "../../../layout/navbar/navbar.component";

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [HeaderComponent, TranslatePipe, NavbarComponent],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.css'
})
export class WelcomeComponent {
  user: string = ""
  constructor(private router: Router, private tokenService: TokenService) {
  }

  ngOnInit() {
    this.user = this.tokenService.obtainNameUser() 
  }
}
